import React from 'react';
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import DOMPurify from "isomorphic-dompurify";
import { resolvePath } from '@utils/resolvePath';
import { Container, IconContainer, TextContainer } from './styles';

export interface ICheckoutCard extends CommonProps {
  text: string;
  icon?: {
    imgSrc: string;
    width?: number;
    height?: number;
    alt?: string;
  };
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const CheckoutNoteCard = (props: ICheckoutCard) => {
  const { is_visible, text, icon, styles, id } = props;

  const { imgSrc, height, width, alt } = icon || {};

  return (id && is_visible) || !id ? (
    <Container styles={styles}>
      {imgSrc && (
        <IconContainer>
          <ImageContainer
            imgSrc={resolvePath(imgSrc)}
            height={height}
            width={width}
            alt={alt}
          />
        </IconContainer>
      )}

      <TextContainer
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text)
        }}
      />
    </Container>
  ) : null;
};

export default connect(mapStateToProps)(CheckoutNoteCard);